module.exports = __webpack_public_path__ + "static/export4-min-f2103210cb8f9a3563d117dd90725a4a.png";